import { hubBaseUrl } from '@shared/lib/auditLogger';
import { isKiosk } from '@shared/lib/constants';
import { getAuthToken } from './authToken';

export interface Robot {
  // Serial — used for routing (`?robot_id=`), proxy URLs, and as the join key
  // against the hub's `Robot.name` column.
  id: string;
  name?: string;
  // Hub's int Robot.id, when known. Cloud users get this from /fleet/inventory;
  // kiosk leaves it undefined (the resolver will fetch it on demand).
  hubId?: number;
}

interface HubInventoryRobot {
  id: number;
  name: string;
}

export async function fetchUserRobots(orgId: number, token?: string | null): Promise<Robot[]> {
  const tok = token ?? getAuthToken();
  if (!tok && !isKiosk) return [];

  const headers: Record<string, string> = {};
  if (tok) headers.Authorization = `Bearer ${tok}`;

  const r = await fetch(`${hubBaseUrl()}/fleet/inventory?org_id=${orgId}`, { headers });
  if (!r.ok) throw new Error(`Fleet inventory ${r.status}`);
  const list = (await r.json()) as HubInventoryRobot[];
  return list.map((r) => ({ id: r.name, name: r.name, hubId: r.id }));
}
